document.addEventListener('DOMContentLoaded', function() {
    var tabs = document.querySelectorAll('.where-to-buy-store__tab');
    var contents = document.querySelectorAll('.where-to-buy-store__content-item');
    function showTab(tabName) {
        console.log('Showing tab:', tabName);
        contents.forEach(function(content) {
            content.style.display = content.getAttribute('data-tab-content') === tabName ? 'grid' : 'none';
        });
    }
    tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
            showTab(tab.getAttribute('data-tab'));
            tabs.forEach(function(t) { t.classList.remove('active'); });
            tab.classList.add('active');
        });
    });
    // 默认显示第一个tab内容
    if (tabs.length > 0) {
        tabs[0].classList.add('active');
        showTab(tabs[0].getAttribute('data-tab'));
    }
});